import { RESULT_STATUS } from "./result";
import { isModuleRegistered } from "SharedStores/util";
import { PROJECT_TYPES, PROJECT_NAMESPACE } from "SharedStores/Project/projectStore";
import { PROGRAM_NAMESPACE, PROGRAM_TYPES } from "SharedStores/Program/programStore";
import { HelperEvaluator } from "./helper";

export class ChoiceEvaluator extends HelperEvaluator {
    constructor(formulaEvaluator, storeContext) {
        super(formulaEvaluator, storeContext);
    }

    choiceEqualTo(exp) {
        exp.usingDefault = false;

        if (isModuleRegistered(PROJECT_NAMESPACE, this.state) && isModuleRegistered(PROGRAM_NAMESPACE, this.state)) {
            if (exp.PublicDataFieldDefinitionId && exp.ListItemDefinitionId) {
                const expListItem = this.getters[PROGRAM_TYPES.getters.listItemFromId](
                    exp.ListItemDefinitionId.toString()
                );

                //the value in the store is actually the listItemId as a string
                const projectValIdStr = this.getters[PROJECT_TYPES.getters.dataFieldValueFromId](
                    exp.PublicDataFieldDefinitionId
                );
                let val = null;

                if (!projectValIdStr || projectValIdStr == "-1") {
                    exp.usingDefault = true;
                    val = exp.StringConstantValue || "";
                } else {
                    val = this.getters[PROGRAM_TYPES.getters.listItemFromId](projectValIdStr).Value;
                }

                const metadata = { projectValue: val };
                return { Value: val === expListItem.Value, metadata: metadata };
            }
            exp.inError = true;
            exp.errorMessage = "No datafield reference specified, or no choice specified.";
            return { Status: RESULT_STATUS.Error, Message: exp.errorMessage };
        }

        exp.inError = true;
        exp.errorMessage = "Project context not found to evaluate data field reference.";
        return { Status: RESULT_STATUS.Error, Message: exp.errorMessage };
    }

    choiceNotEqualTo(exp) {
        const result = this.choiceEqualTo(exp);
        const negation = this._negateResult(result);
        negation.metadata = result.metadata;
        return negation;
    }
}
